// ArticlesContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../FirebaseConfig";

// Create the context
const ArticlesContext = createContext();

// Provider component
export const ArticlesProvider = ({ children }) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch articles in real-time
    const unsubscribe = onSnapshot(
      collection(db, "articles"),
      (snapshot) => {
        const articlesData = snapshot.docs.map((doc) => ({
          id: doc.id, // Include the document ID
          ...doc.data(), // Spread the document fields
        }));
        setArticles(articlesData);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching articles: ", error);
        setLoading(false);
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  return (
    <ArticlesContext.Provider value={{ articles, loading }}>
      {children}
    </ArticlesContext.Provider>
  );
};

// Custom hook for consuming the context
export const useArticles = () => {
  return useContext(ArticlesContext);
};
